import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import AppContainer from "../../common/AppContainer";
import { createSelector } from "../../common/orm";
import SectionTabHeader from "./SectionTabHeader";
import TopButtons from "./TopButtons";
import ViewRecordTable from "../table/ViewRecordTable";
import ViewContactsTable from "../table/ViewContactsTable";
import { withStyles } from "@material-ui/core";

const getPermission = createSelector(
    (state, ownProps) => parseInt(ownProps.match.params["pageId"]),
    (session, pageID) => {
        // Get all permissions related to the page id
        return session.Permission.filter((p) => p.page === pageID).toRefArray();
    }
);

const getPage = createSelector(
    (state, ownProps) => parseInt(ownProps.match.params["pageId"]),
    (session, pageID) => {
        // Get the specific page we are on
        return session.Page.withId(pageID);
    }
);

const getSection = createSelector(
    (state, ownProps) => parseInt(ownProps.match.params["sectionId"]),
    (session, sectionId) => {
        // Get the specific section we are on
        return session.Section.withId(sectionId);
    }
);

const styles = () => ({});

class ChildTables extends Component {

    ACCESS_KEYS = [
        "fullaccess",
        "fullaccess_no_parent_delete",
        "fullaccess_no_delete",
        "readonly",
        "readonlyexternal",
        "noaccess",
    ];

    getAccessValueFromPerm = (perm) => {
        if (!perm) return ""; // default fallback if no row yet
        for (const k of this.ACCESS_KEYS) if (perm[k]) return k;
        return "";
    };

    getDeleteRights = (access) => {
        switch (access) {
            case "fullaccess":
                return { canDeletePrimary: true, canDeleteRelated: true };
            case "fullaccess_no_parent_delete":
                return { canDeletePrimary: false, canDeleteRelated: true };
            case "fullaccess_no_delete":
            case "readonly":
            case "readonlyexternal":
            case "noaccess":
            default:
                return { canDeletePrimary: false, canDeleteRelated: false };
        }
    };

    render() {
        const { section, page, authState, permission } = this.props;

        if (!page) return "";

        if (authState.user) {
            var readOnly;
            var perm = permission.find((p) => {
                if (p.user === authState.user.id) {
                    return p;
                }
                return null;
            });
            if (perm) readOnly = perm.readonly || perm.readonlyexternal ? true : false;
            if (readOnly === undefined) readOnly = false;
        }

        const access = this.getAccessValueFromPerm(perm);
        const { canDeletePrimary, canDeleteRelated } = this.getDeleteRights(access);
        const readOnlyFromAccess = ["readonly", "readonlyexternal", "noaccess"].includes(access);

        const finalReadOnly = readOnlyFromAccess;
        const { navState } = this.props;


        const baseline = window.innerWidth >= 960 ? 36 : 82;
        const contentMarginTop = (navState?.tabHeaderHeight || 72) + baseline;

        return (
            <AppContainer authenticated>
                <Grid container spacing={0} style={{ height: "calc(100% - 45px)" }}>
                    <Grid item xs={12}>
                        <TopButtons perm={perm} section={section} page={page} authState={authState} readOnly={readOnly} showPageName={true} />
                    </Grid>
                    <Grid
                        item
                        xs={12}
                    >
                        <SectionTabHeader value={section.id} />
                    </Grid>

                    {section.is_master_contact_form && (
                        <Grid item xs={12} style={{ height: "100%" }}>
                            <ViewContactsTable />
                        </Grid>
                    )}
                    {!section.is_master_contact_form && (
                        <Grid item xs={12} style={{ height: "100%", marginTop: contentMarginTop }}>
                            <ViewRecordTable
                                newSection={section}
                                pageID={page.id}
                                canDeletePrimary={canDeletePrimary}
                                canDeleteRelated={canDeleteRelated}
                                readOnly={finalReadOnly}
                                noInternalMargin
                            />
                        </Grid>
                    )}
                </Grid>
            </AppContainer>
        );
    }
}
ChildTables.displayName = "ChildTables";

ChildTables = connect(
    (state, ownProps) => ({
        navState: state.nav,
        authState: state.auth,
        permission: getPermission(state, ownProps),
        page: getPage(state, ownProps),
        section: getSection(state, ownProps),
    }),
    null
)(ChildTables);

export default withStyles(styles)(withRouter(ChildTables));
